import pillBottle from "assets/images/pill-bottle.png";
import {unauthLayout as strings} from "strings";

import {ButtonLinkProps} from "components/Button";
import MobileNavigationHeader from "components/MobileNavigationHeader";

import styles from "./UnauthLayout.module.css";

type Props = {
  rightLink?: {label: string} & ButtonLinkProps;
  leftLink?: {label: string} & ButtonLinkProps;
  children: React.ReactNode;
};

export default function UnauthLayout(props: Props) {
  return (
    <div className={styles.container}>
      <MobileNavigationHeader
        rightLink={props.rightLink}
        leftLink={props.leftLink}
      />
      <div className={styles.pageContainer}>
        <div className={styles.textColumn}>
          <div className={styles.textContainer}>{props.children}</div>
        </div>
        <div className={styles.imageCol}>
          <img
            src={pillBottle}
            alt={strings.pillBottle}
            className={styles.image}
          />
        </div>
      </div>
    </div>
  );
}
